import "../../../../content/projects/weigandt/weigandt.css";
import * as React from 'react';
export default {
  React
};